import React, { useEffect, useState } from "react";

const scrollToForm = () => {
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

/**
 * Mobile sticky CTA that smooth-scrolls to lead form.
 * Hidden on desktop. Hidden while the form itself is in view.
 * STRICTLY no tel: link — strictly a lead-form CTA.
 */
export default function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const form = document.getElementById("lead-form");
    if (!form) return;
    let pastHero = false;
    let formInView = false;

    const onScroll = () => {
      pastHero = window.scrollY > window.innerHeight * 0.4;
      setVisible(pastHero && !formInView);
    };

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          formInView = e.isIntersecting;
          setVisible(pastHero && !formInView);
        });
      },
      { threshold: 0.2 }
    );
    obs.observe(form);

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      obs.disconnect();
    };
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      aria-hidden={!visible}
      className={`md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0F2240]/95 backdrop-blur-xl border-t border-[#B89968]/30 px-4 py-3 transition-transform duration-500 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <button
        onClick={scrollToForm}
        data-testid="sticky-mobile-cta-button"
        className="w-full bg-[#B89968] hover:bg-[#CFB079] text-[#0F2240] py-4 font-bold uppercase tracking-[0.18em] text-sm transition-colors"
      >
        Get Help Now →
      </button>
    </div>
  );
}
